import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import BackButton from './BackButton';

export default function AppHeader({ appName = 'AskStewie', showBackButton = true, user, onLogout }) {
  const navigate = useNavigate();
  const location = useLocation();
  const isHome = location.pathname === '/';
  const isAuth = location.pathname === '/login' || location.pathname === '/register';

  if (isAuth) return null;

  return (
    <header className="as-app-header" data-testid="app-header">
      <div className="as-header-inner">
        <div className="as-header-left">
          {showBackButton && !isHome && (
            <BackButton />
          )}

          <button
            type="button"
            onClick={() => navigate('/')}
            className="as-logo-btn"
            aria-label="Go to home screen"
            data-testid="header-logo"
          >
            <img
              src="/stewie_avatar.png"
              alt={`${appName} logo`}
              className="as-logo-img"
            />
            <span className="as-logo-text">{appName}</span>
          </button>
        </div>

        <div className="as-header-right">
          {user && (
            <span className="as-header-user" data-testid="header-user-name">
              {user.first_name || user.email?.split('@')[0]}
            </span>
          )}
          {user && onLogout && (
            <button
              onClick={onLogout}
              className="as-header-logout"
              data-testid="header-logout-btn"
            >
              Sign Out
            </button>
          )}
        </div>
      </div>
    </header>
  );
}
